const mainRouter = [
  //审批
  {
    path: '/approve/approval-list',
    component: () => import('@/views/admin/approve/ApprovalMain'),
    meta: { title: '流程设置' }
  },
  {
    path: '/main/signatureAdd',
    name: 'signatureAdd',
    component: () => import('@/views/admin/signature/SignatureAdd'),
    meta: { title: '添加印章', companyVerify: true, personVerify: true }
  },
  {
    path: '/main/stampList',
    name: 'stampList',
    component: () => import('@/views/admin/signature/StampList'),
    meta: { title: '印章列表' }
  },
  {
    path: '/main/signatureHolder',
    name: 'signatureHolder',
    component: () => import('@/views/admin/signature/SignatureHolder'),
    meta: { title: '印章持有人列表', companyVerify: true }
  },
  {
    path: '/main/signatureAuthorizationDetail',
    name: 'signatureAuthorizationDetail',

    component: () => import('@/views/admin/signature/SignatureAuthorizationDetail'),
    meta: { title: '授权代表人详情', companyVerify: true }
  }
]
export default mainRouter
